/* Program Name: generalAPI.js
 **  Description:
 **
 ** Project   Date        Who  Comments
 ** --------  ----------  ---  ---------------------------------------------------
 ** IS200324  2022-03-28  caa  Original.
 ** IS200324  2023-08-08  tjs  Added giveCartProxy and checkProxy
 ** SD6391    2024-12-17  sgs  Added takeCart on ttRequest of proxyUser call and
                               getAllActiveCarts
 ** SD6391    2024-12-23  sgs  Added uploadSupportPDF
 *******************************************************************************/

import axios from 'axios'
import TS from './TS'
import { ezpopURL } from '../Components/Common/ezpopURL'
import { v4 as uuidv4 } from 'uuid'

export const setData = (obj) => {
  var bodyFormData = new FormData()
  bodyFormData.set('corr', uuidv4())
  if (obj) bodyFormData.set('data', JSON.stringify(obj))
  return bodyFormData
}

export const getMeta = () => {
  return TS.post('user/meta_rdr', setData({ ttRequest: [{ mode: 'all' }] }))
}

export const getUserMeta = () => {
  return TS.post('user/meta_rdr', setData({ ttRequest: [{ mode: 'user' }] }))
}

export const getUserLookupList = (options) => {
  return TS.post(
    'user/lookup_rdr',
    setData({ ttRequest: [{ mode: 'all', options: options }] })
  )
}

export const getUserLookupListNoSeri = () => {
  return TS.post('user/lookup_rdr', setData({ ttRequest: [{ mode: 'all' }] }))
}

export const getUserLookup = (id) => {
  return TS.post(
    'user/lookup_rdr',
    setData({ ttRequest: [{ mode: 'single', id: id }] })
  )
}

export const getStoreLookup = (storeNum, options) => {
  return TS.post(
    'user/lookup_rdr',
    setData({
      ttRequest: [{ mode: 'store', storeNum: storeNum, options: options }],
    })
  )
}

export const forgotPassword = (user, cust) => {
  return TS.post(
    'user/log_in',
    setData({ login: [{ username: user, customer: cust, mode: 'forgotpw' }] })
  )
}

export const getLoginDomains = (domain) => {
  return TS.post(
    'domain_registry/domain_registry_rdr',
    setData({ ttRequest: [{ mode: 'all', custCode: domain }] })
  )
}

export const getCartCount = () => {
  return TS.post(
    'shop/cart_rdr',
    setData({ ttRequest: [{ mode: 'itemCount' }] })
  )
}

export const acceptSiteMessage = (json) => {
  return TS.post('support/site_message_upd', setData(json))
}

export const getOrderSummary = () => {
  return TS.post('shop/cart_rdr', setData({ ttRequest: [{ mode: 'summary' }] }))
}

export const getSupport = () => {
  return TS.post(
    'support/support_rdr',
    setData({ ttRequest: [{ mode: 'all' }] })
  )
}

export const uploadSupportPDF = (file, id) => {
  return fileUpload(
    { ttRequest: [{ mode: 'upload', linkId: id }] },
    file,
    '/scripts/faq_link_upload'
  )
}

export const removeSupportPDF = (id) => {
  return fileRemove(
    { ttRequest: [{ mode: 'remove', linkId: id }] },
    '/scripts/faq_link_file_remove'
  )
}

export const fileRemove = (request, url) => {
  var requestFormData = new FormData()
  requestFormData.set('data', JSON.stringify(request))

  return axios.post(`${ezpopURL}${url}`, requestFormData, {
    withCredentials: true,
    headers: {
      'content-type': 'multipart/form-data',
    },
  })
}

export const fileUpload = (request, file, url) => {
  var requestFormData = new FormData()
  requestFormData.set('data', JSON.stringify(request))
  requestFormData.set('fileData', file)

  return axios.post(`${ezpopURL}${url}`, requestFormData, {
    withCredentials: true,
    headers: {
      'content-type': 'multipart/form-data',
    },
  })
}

export const logout = () => {
  return TS.post('user/log_out')
}

export const resetSess = () => {
  return TS.post('user/reset_timeout')
}

export const proxyUser = (id, takeUserCart) => {
  return TS.post(
    'shop/shop_filter_upd',
    setData({
      ttRequest: [
        {
          mode: 'select',
          cat: 'shoptarget',
          userId: id,
          takeCart: takeUserCart,
        },
      ],
    })
  )
}

export const unProxyUser = () => {
  return TS.post(
    'shop/shop_filter_upd',
    setData({ ttRequest: [{ mode: 'clear', cat: 'shoptarget' }] })
  )
}

export const giveCartProxy = (id) => {
  return TS.post(
    '/shop/cart_upd',
    setData({ ttRequest: [{ mode: 'givecart', scope: 'proxy', userId: id }] })
  )
}

export const checkProxy = () => {
  return TS.post('user/lookup_rdr', setData({ ttRequest: [{ mode: 'proxy' }] }))
}

export const checkProxyCarts = (id) => {
  return TS.post(
    '/user/lookup_rdr',
    setData({ ttRequest: [{ mode: 'proxy-cart-check', id: id }] })
  )
}
